// src/utils/deviceFingerprint.js
// Generates a browser-based device fingerprint for trusted device feature

const STORAGE_KEY = 'easyCheckDeviceId';

/**
 * Simple hash function (djb2) for combining fingerprint components
 */
const hashString = (str) => {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash).toString(36);
};

/**
 * Collect browser properties to generate a fingerprint
 */
const collectFingerprint = () => {
  const components = [];

  // Screen properties
  components.push(`${window.screen.width}x${window.screen.height}`);
  components.push(`${window.screen.colorDepth}`);
  components.push(`${window.screen.pixelDepth}`);

  // Timezone
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone);

  // Language
  components.push(navigator.language);

  // Platform
  components.push(navigator.platform);

  // Hardware concurrency
  components.push(`cores:${navigator.hardwareConcurrency || 'unknown'}`);

  // Device memory (Chrome only)
  components.push(`mem:${navigator.deviceMemory || 'unknown'}`);

  // Touch support
  components.push(`touch:${navigator.maxTouchPoints || 0}`);

  // Canvas fingerprint
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 200;
    canvas.height = 50;
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.font = '11pt Arial';
    ctx.fillText('EasyCheck', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.font = '18pt Arial';
    ctx.fillText('Device', 4, 45);
    components.push(`canvas:${hashString(canvas.toDataURL())}`);
  } catch (e) {
    components.push('canvas:unavailable');
  }

  // WebGL renderer
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (gl) {
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        components.push(`gl:${gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)}`);
      }
    }
  } catch (e) {
    components.push('gl:unavailable');
  }

  return hashString(components.join('|'));
};

/**
 * Get or generate device fingerprint.
 * Returns a consistent fingerprint string for this browser/device.
 */
export const getDeviceFingerprint = () => {
  let fingerprint = localStorage.getItem(STORAGE_KEY);
  if (!fingerprint) {
    fingerprint = collectFingerprint();
    localStorage.setItem(STORAGE_KEY, fingerprint);
  }
  return fingerprint;
};
